import React, { Component } from "react";
import styled from "styled-components";
import { observer } from "mobx-react";
import { CaseManagementStore, IsTicketingEnabled } from "Store";
import { Scrollbars } from "react-custom-scrollbars";
import Avatar from "module-common/Avatar";
import Header from "./Header";
import CustomerField from "./customer-field/CustomerFieldWithQueryMutation";
import CustomerNote from "./CustomerNoteWithQueryMutation";
import CaseNote from "./CaseNoteWithMutation";
import LabelListCase from "./TreeLabelListCaseWithQueryMutation";
import LabelListCustomer from "./TreeLabelListCustomerWithQueryMutation";
import TicketPanel from './ticketing/TicketPanel'

// this component is responsible for showing info panel
export default observer(
  class InfoPanel extends Component {
    render() {
      const { selectedCase, showInfoPanel, selectedTab } = CaseManagementStore;

      // check if user selected open case
      const showingContentPanel =
        selectedCase && selectedCase.progressType === "OPEN";

      // check if we show info panel
      const showingInfoPanel = showingContentPanel && showInfoPanel;

      // make info panel editable if not in all tab
      const editable = selectedTab !== "all";

      // early out if not showing info panel
      if (!showingInfoPanel) return null;

      // get case field
      const {
        id,
        labels,
        noteInfo,
        customerChannelHandler: { displayPicture, displayName }
      } = selectedCase;

      return (
        <Wrapper>
          <Header onClick={this.onClosePanel} />
          <Scrollbars>
            <ContentWrapper>
              {IsTicketingEnabled() && (<Ticketing>
                <TitleRow>
                  <Title>Ticketing</Title>
                </TitleRow>
                <TicketPanel case={{ id }} editable={editable} />
              </Ticketing>)}              
              <Customer>
                <TitleRow>
                  <Title>Customer Profile</Title>
                </TitleRow>
                <StyledLabelListCustomer case={{ id }} editable={editable} />
                <Info>
                  <CustomerInfo>
                    <Avatar image={displayPicture} />
                  </CustomerInfo>
                  <CustomerField
                    customerName={displayName}
                    case={{ id }}
                    editable={editable}
                  />
                </Info>
                <CustomerNote case={{ id }} editable={editable} />
              </Customer>
              <Case>
                <TitleRow>
                  <Title>Case Info</Title>
                </TitleRow>
                <StyledLabelListCase
                  id={id}
                  labels={labels.slice()}
                  editable={editable}
                />
                <CaseNote
                  case={{ id }}
                  note={noteInfo ? noteInfo.content : ""}
                  editable={editable}
                />
              </Case>
            </ContentWrapper>
          </Scrollbars>
        </Wrapper>
      );
    }

    onClosePanel = () => {
      CaseManagementStore.showInfoPanel = false;
    };
  }
);

const Wrapper = styled.div`
  flex: none;
  width: 300px;
  display: flex;
  flex-direction: column;
  border-left: 1px solid ${props => props.theme.panelBorder};
`;
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
const TitleRow = styled.div`
  display: flex;
  margin-bottom: 10px;
`;
const Title = styled.div`
  color: ${props => props.theme.uiText};
  font-size: 0.8rem;
  font-weight: bold;
  margin-right: auto;
`;
const Ticketing = styled.div`
  padding: 20px;
  border-bottom: 1px solid ${props => props.theme.panelBorder};
`
const Customer = styled.div`
  padding: 20px;
  border-bottom: 1px solid ${props => props.theme.panelBorder};
`;
const Case = styled.div`
  padding: 20px;
`;
const Info = styled.div`
  display: flex;
  margin-bottom: 10px;
`;
const CustomerInfo = styled.div`
  display: flex;
  flex-direction: column;
`;
const StyledLabelListCase = styled(LabelListCase)`
  margin-bottom: 16px;
`;
const StyledLabelListCustomer = styled(LabelListCustomer)`
  margin-bottom: 16px;
`;



// WEBPACK FOOTER //
// ./src/module-case-management/info-panel/InfoPanelWithStore.js